/*
 * Maison Panoramique : petits composants d'interface (aucune dépendance).
 * <mp-gallery> : points de navigation de la galerie mobile (défilement natif, scroll-snap).
 * <mp-compare> : comparateur glissant teinte sombre / teinte claire (piloté par un champ range accessible).
 */
(function () {
  'use strict';

  if (!customElements.get('mp-gallery')) {
    class MpGallery extends HTMLElement {
      connectedCallback() {
        var track = this.querySelector('[data-gallery-track]');
        var dots = this.querySelector('[data-gallery-dots]');
        if (!track || !dots) return;
        var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
        if (slides.length < 2) return;
        slides.forEach(function (s, i) {
          var b = document.createElement('span');
          b.className = 'mp-gallery__dot' + (i === 0 ? ' is-active' : '');
          dots.appendChild(b);
        });
        var dotEls = Array.prototype.slice.call(dots.children);
        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.6) {
              var i = slides.indexOf(en.target);
              dotEls.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
    }
    customElements.define('mp-gallery', MpGallery);
  }

  if (!customElements.get('mp-compare')) {
    class MpCompare extends HTMLElement {
      connectedCallback() {
        var range = this.querySelector('input[type="range"]');
        if (!range) return;
        var self = this;
        var set = function () { self.style.setProperty('--pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      }
    }
    customElements.define('mp-compare', MpCompare);
  }

  /* Bandeau cookies de Shopify : son lien « Politique de confidentialité » pointe vers /fr/policies/privacy-policy,
     qui répond 404. On le dirige vers /policies/privacy-policy (le bandeau est injecté après le chargement). */
  function fixPrivacyLinks(root) {
    (root || document).querySelectorAll('a[href*="/policies/privacy-policy"]').forEach(function (a) {
      var href = a.getAttribute('href');
      var fixed = href.replace(/^(https?:\/\/[^/]+)?\/[a-z]{2}(-[a-z]{2})?\/policies\/privacy-policy/i, '$1/policies/privacy-policy');
      if (fixed !== href) a.setAttribute('href', fixed);
    });
  }
  fixPrivacyLinks();
  if ('MutationObserver' in window) {
    var privacyObserver = new MutationObserver(function () { fixPrivacyLinks(); });
    privacyObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { privacyObserver.disconnect(); }, 20000);
  }

  /* Colonne collante plus haute que l'écran (galerie de la fiche motif) : top négatif pour qu'elle défile
     jusqu'à sa dernière vue, puis reste visible tant que la colonne voisine continue. */
  function stickTall() {
    var vh = window.innerHeight;
    document.querySelectorAll('.mp-pdp__gallery').forEach(function (el) {
      var top = Math.min(96, vh - el.offsetHeight - 24);
      el.style.setProperty('--mp-sticky-top', top + 'px');
    });
  }
  if (document.querySelector('.mp-pdp__gallery')) {
    stickTall();
    window.addEventListener('resize', stickTall);
    window.addEventListener('load', stickTall);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(stickTall);
      document.querySelectorAll('.mp-pdp__gallery').forEach(function (el) { ro.observe(el); });
    }
  }
})();
